import Dynamic from '@base/Dynamic/Dynamic';
import FaqLevels from '@educator/LevelsAndLeaderboard/FaqLevels';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import { Typography } from 'aquilla/core/atoms/Typography';
import React, { useState } from 'react';
import { EX_EDUCATOR_CONFIG, PARTNER_EDUCATOR_CONFIG } from './constants';

const Expert = Dynamic(() => import('aquilla/icons/levels/Expert'));
const Legend = Dynamic(() => import('aquilla/icons/levels/Legend'));
const Star = Dynamic(() => import('aquilla/icons/levels/Star'));
const Master = Dynamic(() => import('aquilla/icons/levels/Master'));
const RisingStar = Dynamic(() => import('aquilla/icons/levels/RisingStar'));
const Partner = Dynamic(() => import('aquilla/icons/levels/PartnerBadge'));

const badges = {
  master: Master,
  legend: Legend,
  expert: Expert,
  star: Star,
  risingstar: RisingStar,
  partner: Partner
};
const EducatorLevelWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_6};
  align-items: flex-start;
`;

const EducatorLevel = styled(Typography)`
  font-weight: ${Fonts.HEAVY};
  line-height: unset;
  text-transform: ${({ $isExEducator }) =>
    $isExEducator ? 'unset' : 'uppercase'};
  cursor: ${({ $isPartner }) => ($isPartner ? 'auto' : 'pointer')};
`;

const StyledTypography = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
  text-transform: initial;
`;

const EducatorLevelTagNew = ({
  educatorLevel,
  levelInfo,
  isPartnerEducator = false,
  isExEducator = false
}) => {
  const [showLevelsFaq, setShowLevelsFaq] = useState(false);

  const openFaqScreen = () => {
    if (isPartnerEducator) return;
    setShowLevelsFaq(true);
  };

  const closeFaqScreen = () => {
    setShowLevelsFaq(false);
  };

  let educatorLevelName = educatorLevel?.name;
  let tagColor = educatorLevel?.color?.primary || 'var(--color-base-1)';
  let badgeKey = educatorLevel?.name?.toLowerCase().replace(' ', '');
  if (isPartnerEducator) {
    educatorLevelName = PARTNER_EDUCATOR_CONFIG.name;
    tagColor = PARTNER_EDUCATOR_CONFIG.color.primary;
    badgeKey = 'partner';
  }
  if (isExEducator) {
    educatorLevelName = EX_EDUCATOR_CONFIG.name;
    tagColor = EX_EDUCATOR_CONFIG.color.primary;
    badgeKey = 'exEducator';
  }

  const BadgeComponent = badges[badgeKey];
  return (
    <>
      {educatorLevelName && (
        <EducatorLevelWrapper className="web" onClick={openFaqScreen}>
          {!isExEducator && BadgeComponent && (
            <BadgeComponent height="20" width="20" />
          )}
          <EducatorLevel
            $isPartner={isPartnerEducator}
            $isExEducator={isExEducator}
            variant="h6"
            color={tagColor}
          >
            {' '}
            {educatorLevelName}{' '}
            <StyledTypography
              variant="p2"
              as="span"
              color="var(--color-text-secondary)"
            >
              {levelInfo?.goal?.name ? `in ${levelInfo?.goal?.name}` : ''}
            </StyledTypography>
          </EducatorLevel>
        </EducatorLevelWrapper>
      )}
      {showLevelsFaq && (
        <FaqLevels
          isOpen={showLevelsFaq}
          onClose={closeFaqScreen}
          onPressBack={closeFaqScreen}
          isPublic
        />
      )}
    </>
  );
};

export default EducatorLevelTagNew;
